import { absoluteBaseUrl } from '~/constants/environment';

export const SELL_MY_CAR_URL = `${absoluteBaseUrl}/sell-my-car`;
